export const FORM_TASLAK_TIP_SIPARIS_LEGACY = 'siparis';
export const FORM_TASLAK_TIP_SIPARIS_GARANTI = 'siparis-garanti';
export const FORM_TASLAK_TIP_SIPARIS_DOGRUDAN = 'siparis-dogrudan';
export const FORM_TASLAK_TIP_SIPARIS_KONSIYE = 'siparis-konsinye';

export const SIPARIS_TASLAK_DEFS = [
  {
    tip: FORM_TASLAK_TIP_SIPARIS_GARANTI,
    label: 'Garanti dahilinde taslağı',
    shortLabel: 'Garanti dahilinde',
    icon: 'fa-shield-alt',
    color: '#10b981',
    garantiDahilinde: true,
    konsinye: false,
  },
  {
    tip: FORM_TASLAK_TIP_SIPARIS_DOGRUDAN,
    label: 'Doğrudan alım taslağı',
    shortLabel: 'Doğrudan alım',
    icon: 'fa-shopping-cart',
    color: '#2563eb',
    garantiDahilinde: false,
    konsinye: false,
  },
  {
    tip: FORM_TASLAK_TIP_SIPARIS_KONSIYE,
    label: 'Konsinye taslağı',
    shortLabel: 'Konsinye',
    icon: 'fa-box-open',
    color: '#8b5cf6',
    garantiDahilinde: false,
    konsinye: true,
  },
];

export function getSiparisTaslakDef(tip) {
  return SIPARIS_TASLAK_DEFS.find((d) => d.tip === tip) || null;
}

export function getSiparisTaslakTipFromFlags(garantiDahilinde, konsinye) {
  if (garantiDahilinde) return FORM_TASLAK_TIP_SIPARIS_GARANTI;
  if (konsinye) return FORM_TASLAK_TIP_SIPARIS_KONSIYE;
  return FORM_TASLAK_TIP_SIPARIS_DOGRUDAN;
}

export function taslakHasContent(veri, photoCount = 0) {
  if (!veri) return photoCount > 0;
  return (
    (veri.secilenParcalar?.length > 0) ||
    !!veri.not?.trim() ||
    veri.servisKaydiSnapshot ||
    veri.servisKaydiId ||
    photoCount > 0
  );
}

export function countTaslakParca(veri) {
  if (!Array.isArray(veri?.secilenParcalar)) return 0;
  return veri.secilenParcalar.reduce((sum, p) => sum + (p.adet || 1), 0);
}
